import request from '@/utils/request'

export function getStaffProfileQualityOverview () {
  return request({
    url: '/addon/staffProfileQuality/overview',
    method: 'get'
  })
}
